import React from 'react';

export default class HowItWorks extends React.Component {

  render() {
    return(
      <div className='row how-it-works'>
        <div className='col-sm-12'>
          <div className='row how-it-works-item bottom-spacer'>
            <div className='col-sm-4'>
              <h4>1) Find a word.</h4>
               Email <a href='mailto:word@yaktack.com?subject=edification' target='_blank' rel="noopener noreferrer">word@yaktack.com</a> with the word you'd like to remember in the subject line. Or type the word into Yak Tack above.
            </div>
            <div className='col-sm-8'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/email.png'></img>
            </div>
          </div>
          <div className='row how-it-works-item bottom-spacer'>
            <div className='col-sm-4'>
              <h4>2) Read the definition.</h4>
              Get an email with the definition at expanding daily intervals. This is known as <a href="https://en.wikipedia.org/wiki/Spaced_repetition">spaced repetition</a>.
              Read the definition. Process it. Delete the email. We stop at day 13. We call this process <b>tacking</b>.
            </div>
            <div className='col-sm-8'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/day-1.png'></img>
            </div>
          </div>
          <div className='row how-it-works-item bottom-spacer'>
            <div className='col-sm-4'>
              <h4>3) Remember the word.</h4>
              After each interval, the definition will be easier to remember when you hear or read it again.
            </div>
            <div className='col-sm-8'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/edification-in-the-wild.png'></img>
            </div>
          </div>
          <div className='row how-it-works-item'>
            <div className='col-sm-4'>
              <h4>4) Follow people to find new words.</h4>
              Connect with other people on Yak Tack to continue expanding your vocabulary.
            </div>
            <div className='col-sm-8'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/follow.png'></img>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/how_it_works.jsx